import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import ValidatorTextField from "../../../FormFields/ValidatorTextField";
import MenuItem from "@mui/material/MenuItem";
import { insuranceNumberFieldDefault, requiredValidator } from "../../../../services/validationRules";
import { PARTNER_IRIS, PartnerIri } from "../../../../constants/partnerIris";
import BasePersonConsultingCheckin from "../../Common/Consulting/BasePersonConsultingCheckin.tsx";
import React, { useEffect } from "react";
import { useForm } from "../../../../provider/Form/FormProvider.tsx";
import { getProductData } from "../../../../services/productService.ts";
import { FormDataTypes } from "../../../../types/FormDataTypes.ts";
import { validateLvmAccount } from "../../../../services/partner/lvmService.ts";

export default function ContractAndCivilLawConsultingCheckin({ partner, idPrefix }: { partner: PartnerIri; idPrefix: string }) {
  return (
    <BasePersonConsultingCheckin
      idPrefix={idPrefix}
      partner={partner}
      getApiProductUri={(product) => getProductData(product, "apiUri")}
      getInitialProduct={(selectedProduct) => selectedProduct}
      renderAdditionalFields={(isLoading) => <AdditionalFields isLoading={isLoading} />}
      {...(partner === PARTNER_IRIS.LVM && {
        preSubmitAction: validateLvmAccount,
      })}
      additionalInitialValues={{ productCategory: "" }}
    />
  );
}

const AdditionalFields = ({ isLoading }: { isLoading: boolean }) => {
  const { values, updateValue }: FormDataTypes = useForm();
  const category = values.productCategory;

  useEffect(() => {
    if (category === "generalCivilLaw") {
      updateValue("product", "generalCivilLaw");
    } else {
      updateValue("product", "");
    }
  }, [category]);

  return (
    <>
      <ValidatorSelectField
        label="Ihre Kategorie"
        name="productCategory"
        validators={[requiredValidator("Bitte wählen Sie eine Kategorie aus.")]}
        disabled={isLoading}
      >
        <MenuItem value={"contractLaw"}>Streitigkeiten im Vertragsrecht</MenuItem>
        <MenuItem value={"generalCivilLaw"}>Streitigkeiten um Schadensersatz und Schmerzensgeld</MenuItem>
      </ValidatorSelectField>

      {category === "contractLaw" && (
        <ValidatorSelectField label="Art des Vertrags" name="product" validators={[requiredValidator("Bitte geben Sie Ihr Anliegen an.")]} disabled={isLoading}>
          <MenuItem value={"purchaseContract"}>Kaufvertrag</MenuItem>
          <MenuItem value={"serviceContract"}>Handwerker / Dienstleistung</MenuItem>
          <MenuItem value={"membershipContract"}>Mitgliedschaft</MenuItem>
          <MenuItem value={"subscriptionContract"}>Abo / Abofalle</MenuItem>
          <MenuItem value={"providerContract"}>Handy / DSL / Strom-Vertrag</MenuItem>
          <MenuItem value={"travelContract"}>Reisevertrag</MenuItem>
          <MenuItem value={"eventContract"}>Veranstaltung</MenuItem>
          <MenuItem value={"otherContract"}>Sonstiger Vertrag</MenuItem>
          <MenuItem value={"vehicleContract"}>Fahrzeugkauf</MenuItem>
        </ValidatorSelectField>
      )}

      <ValidatorTextField
        label="Ihre Versicherungsscheinnummer"
        name="insurancePolicyNumber"
        validators={[requiredValidator("Bitte geben Sie Ihre LVM Versicherungsscheinnummer an."), insuranceNumberFieldDefault]}
        disabled={isLoading}
      />
    </>
  );
};
